import classNames from 'classnames';
import React from 'react';

import SvgIcon from 'common/components/uilib/SvgIcon/SvgIcon';

import styles from './WarningBlocks.scss';

export const WarningIcon = ({ className }: { className: string }) => (
  <SvgIcon className={classNames(styles.icon, className)} viewBox="0 0 66 66" role="img">
    {/* eslint-disable-next-line react/jsx-no-literals -- no i18n needed for svgs */}
    <title>Icons</title>
    <path d="M19.316 0L0 19.316v27.318l19.316 19.315h27.318l19.315-19.315V19.316L46.634 0H19.316zM1.5 46.013V19.937L19.937 1.5h26.076l18.436 18.437v26.076L46.013 64.449H19.937L1.5 46.013z" />
    <path d="M38.16 28.66c0 3.128-.002 6.259.004 9.388.001.466-.156 1.051.544 1.173.657.115.782-.449.984-.88.885-1.897 1.758-3.799 2.65-5.692.589-1.245 1.697-1.558 2.843-.828.705.449.992 1.154.678 1.932-1.351 3.348-2.605 6.744-4.125 10.016-2.758 5.937-10.515 8.664-16.083 5.793-2.938-1.515-4.362-4.083-5.092-7.185-.633-2.688-.645-5.4-.575-8.13.096-3.76.17-7.52.254-11.279.006-.286.016-.574.045-.86.105-1.076.634-1.558 1.675-1.532 1.032.024 1.685.627 1.695 1.659.021 2.497.008 4.996.01 7.494 0 .23-.074.504.025.678.13.232.38.5.613.538.174.027.486-.25.582-.463.11-.242.06-.563.06-.848.005-3.417-.009-6.834.012-10.25.008-1.375 1.253-2.16 2.526-1.624.752.317 1.028.908 1.023 1.718-.02 3.157-.007 6.316-.006 9.474 0 .2-.07.444.018.594.152.26.4.46.61.685.224-.213.514-.391.655-.65.11-.203.037-.506.037-.764.002-3.905-.003-7.81.002-11.715.001-1.308.612-1.896 1.899-1.86 1.113.03 1.608.523 1.61 1.663.007 4.02.002 8.039.002 12.059 0 .2-.072.447.017.594.165.271.426.486.646.724.22-.247.594-.47.633-.744.095-.646.033-1.315.033-1.977 0-2.812-.01-5.626.006-8.44.01-1.248.888-1.974 2.088-1.784.87.14 1.398.752 1.4 1.676.007 3.214.003 6.43.003 9.646" />
  </SvgIcon>
);

export const MatureIcon = () => {
  const cls = classNames(styles.icon, styles.matureIcon);
  return (
    <SvgIcon className={cls} viewBox="0 0 67 67">
      <g>
        <path className={styles.matureEl1} d="M1 66h65V1H1z" />
        <path
          className={styles.matureEl2}
          d="M40 17h10v33h-6V28c-.44-.963-.433-1.861 0-3-.403-1.176-.396-2.068 0-3l-7 28h-6l-7-28c.396.932.403 1.824 0 3 .433 1.139.44 2.037 0 3v22h-6V17h10l6 26 6-26z"
        />
      </g>
    </SvgIcon>
  );
};
